import React, { useState, useRef, useEffect } from 'react';

const BurgerMenu = ({ onOpenSettings, onDownloadState, onDownloadWithSettings, onUploadState, onUploadWithSettings, onShowPlot }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const fileInputRef = useRef(null);
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const handleUploadClick = () => {
    fileInputRef.current.dataset.uploadType = 'regular';
    fileInputRef.current.click();
    setIsOpen(false);
  };
  
  const handleUploadWithSettingsClick = () => {
    fileInputRef.current.dataset.uploadType = 'withSettings';
    fileInputRef.current.click();
    setIsOpen(false);
  };
  
  const handleMenuItemClick = (callback) => {
    callback();
    setIsOpen(false);
  };
  
  
  return (
    <div className="relative" ref={menuRef}>
      {/* Burger Icon */}
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        className="p-2 text-white focus:outline-none"
      >
        <div className="w-6 h-0.5 bg-white mb-1.5"></div>
        <div className="w-6 h-0.5 bg-white mb-1.5"></div>
        <div className="w-6 h-0.5 bg-white"></div>
      </button>
      
      {/* Menu Dropdown */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-md shadow-lg z-50">
          <div className="py-1">
            <button
              onClick={() => handleMenuItemClick(onOpenSettings)}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
            >
              Settings
            </button>
            
            <button
              onClick={() => handleMenuItemClick(onDownloadState)}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
            >
              Download Build Order
            </button>
            
            <button
              onClick={() => handleMenuItemClick(onDownloadWithSettings)}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
            >
              Download Build Order with Settings
            </button>
            
            <button
              onClick={handleUploadClick}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
            >
              Upload Build Order
            </button>
            
            <button
              onClick={handleUploadWithSettingsClick}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
            >
              Upload Build Order with Settings
            </button>
            
            <button
              onClick={() => handleMenuItemClick(onShowPlot)}
              className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
            >
              Show Plot
            </button>
          </div>
        </div>
      )}
      
      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        className="hidden"
        onChange={(e) => {
          const uploadType = fileInputRef.current.dataset.uploadType;
          if (uploadType === 'withSettings') {
            onUploadWithSettings(e);
          } else {
            onUploadState(e);
          }
          e.target.value = null; // Reset input
        }}
      />
    </div>
  );
};

export default BurgerMenu;
